import React, { memo, useEffect, useState } from 'react';

import { EThemesEnum } from '@enum';

import { themeFromLSParser } from '@utils';
import { ToggleContainer } from './ThemeToggle.styled';

import { ThemeToggleProps } from './ThemeToggle.types';

export const ThemeToggle = memo(({ onChange }: ThemeToggleProps) => {
  const [dark, setDark] = useState<boolean>(
    themeFromLSParser() === EThemesEnum.dark,
  );

  const handleChange = () => {
    setDark((prev) => !prev);
  };

  useEffect(() => {
    onChange(dark ? EThemesEnum.dark : EThemesEnum.light);
  }, [dark]);

  return (
    <ToggleContainer
      title={dark ? 'Activate light mode' : 'Activate dark mode'}
      aria-label={dark ? 'Activate light mode' : 'Activate dark mode'}
    >
      <input type="checkbox" defaultChecked={!dark} onChange={handleChange} />
      <div />
    </ToggleContainer>
  );
});
